import type { ReferentialProjectCostType } from "./referential-project-cost-types.type";
import type { UseReferentialOptions } from "@/entities/referential";

import { useReferential, REFERENTIAL_ENDPOINT } from "@/entities/referential";

export const useReferentialProjectCostTypes = (
  options?: UseReferentialOptions<ReferentialProjectCostType[]>
) => {
  const { data: costTypes = [], ...result } = useReferential<
    ReferentialProjectCostType[]
  >(REFERENTIAL_ENDPOINT.PROJECT_COST_TYPES, options);

  return {
    ...result,
    costTypes,
  };
};
